import React from 'react';
import { NextPage } from 'next';
import { Box, Container } from '@mui/material';

import { TabTitle } from 'components/common/TabTitle';
import NotFoundContent from 'components/pageNotFound/NotFoundContent';
import { UserHeader } from 'components/common/Header';
import Footer from '../components/home/Footer';

const NotFoundPage: NextPage & { namespacesRequired?: string[] } = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <TabTitle ns="public" i18nKey="tab.pageNotFound" signLabel="general" />
    <UserHeader />
    <Container maxWidth="xl" sx={{ flex: 1 }}>
      <Box mt={10}>
        <NotFoundContent />
      </Box>
    </Container>
    <Footer />
  </Box>
);

NotFoundPage.namespacesRequired = ['common', 'public'];

export default NotFoundPage;
